import { Injectable } from '@angular/core';
import { createFrom, EventService } from '@spartacus/core';
import { NavigationEvent } from '@spartacus/storefront';
import { filter, map } from 'rxjs/operators';
import { FbqGgProductPageEvent } from './fbq-gg-product-page-event';

@Injectable({
  providedIn: 'root',
})
export class FbqGgProductPageEventBuilder {
  constructor(private eventService: EventService) {
    const fbqGgProductPageEventSource = this.eventService.get(NavigationEvent).pipe(
      filter((navigationEvent) => navigationEvent.semanticRoute === 'product'),
      map(() =>
        createFrom(FbqGgProductPageEvent, {
          event: 'ViewContent',
        })
      )
    );

    eventService.register(FbqGgProductPageEvent, fbqGgProductPageEventSource);
  }
}
